import _ from "lodash";

export const getSentSMSByName = (sentSMS, smsName) => {
  if (!sentSMS) {
    return null;
  }
  const smsInfo = Object.values(sentSMS)
    .sort((a, b) => b.sentTime - a.sentTime)
    .find((sms) => sms.name === smsName);
  if (smsInfo) {
    return smsInfo;
  }
  const legacySMSSentTime = _.get(sentSMS, smsName, null);
  if (legacySMSSentTime) {
    return {
      name: smsName,
      content: null,
      sentTime: legacySMSSentTime,
    };
  }
  return null;
};
